import React, { useState } from 'react';
import Modal from './Modal';
import { generateId } from '../utils/helpers';

export default function ExpenseForm({ isOpen, onClose, onSave, holiday, members }) {
  const [form, setForm] = useState({
    description: '',
    amount: '',
    dueDate: '',
    assignedTo: 'shared',
    isPaid: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.description || !form.amount) return;
    const expense = {
      id: generateId(),
      description: form.description,
      amount: parseFloat(form.amount),
      dueDate: form.dueDate,
      assignedTo: form.assignedTo,
      isPaid: form.isPaid,
      paidDate: form.isPaid ? new Date().toISOString().split('T')[0] : null,
    };
    onSave(holiday.id, expense);
    setForm({ description: '', amount: '', dueDate: '', assignedTo: 'shared', isPaid: false });
    onClose();
  };

  const tripMembers = members.filter(m => holiday?.familyMembers?.includes(m.id));

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Payment / Expense">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Description *</label>
          <input
            type="text"
            value={form.description}
            onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
            placeholder="e.g. Hotel deposit, Flight balance"
            className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:border-purple-400 focus:outline-none"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Amount (£) *</label>
            <input
              type="number"
              value={form.amount}
              onChange={e => setForm(f => ({ ...f, amount: e.target.value }))}
              placeholder="0.00"
              className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:border-purple-400 focus:outline-none"
              min="0"
              step="0.01"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Due Date</label>
            <input
              type="date"
              value={form.dueDate}
              onChange={e => setForm(f => ({ ...f, dueDate: e.target.value }))}
              className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:border-purple-400 focus:outline-none"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Assigned to</label>
          <select
            value={form.assignedTo}
            onChange={e => setForm(f => ({ ...f, assignedTo: e.target.value }))}
            className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:border-purple-400 focus:outline-none bg-white"
          >
            <option value="shared">Shared (everyone)</option>
            {tripMembers.map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
        </div>

        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={form.isPaid}
            onChange={e => setForm(f => ({ ...f, isPaid: e.target.checked }))}
            className="w-5 h-5 rounded border-gray-300 text-purple-500 focus:ring-purple-400"
          />
          <span className="text-sm font-medium text-gray-700">Already paid</span>
        </label>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 px-4 border-2 border-gray-200 rounded-xl text-gray-600 font-semibold hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-2.5 px-4 bg-gradient-to-r from-purple-500 to-teal-500 hover:from-purple-600 hover:to-teal-600 text-white rounded-xl font-semibold transition-colors"
          >
            Add Payment
          </button>
        </div>
      </form>
    </Modal>
  );
}
